import { RecruitmentFilterResponseType } from '../types/RecruitmentTypes';
import _ from 'lodash';
import {ConstantUtils} from "./ConstantUtils";

export const UrlUtils = {
  changeSearchCondition: (
    queryFilters: string | null,
    queryKeyword: string | null,
  ) => {
    const filters = !_.isEmpty(queryFilters)
        ? queryFilters?.split(',').filter(ConstantUtils.convertToRecruitmentFilter).join(',')
        : '';

    const queryString = filters
        ? `?filters=${filters}${!_.isEmpty(queryKeyword) ? `&keyword=${queryKeyword}` : ''}`
        : !_.isEmpty(queryKeyword)
            ? `?keyword=${queryKeyword}`
            : '';

    let path = location.pathname;
    if(path === '/'){
      path += 'recruitment';
    }

    return `${path}${queryString}`;
  },
};